// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lv3TBzI1gVkrBfShzAjb {
  background: rgba(var(--secondary-bg), 0.60);
  border: 1px solid rgba(var(--border), 0.20);
  border-radius: 24px;
  padding: 16px 16px 24px 16px;
  position: relative;
}

.Y7POEWdWqd27HanXSA4G {
  height: 95%;
  overflow-y: auto;
}

.en9t9NhwKQnDss6x7Xea {
  background: transparent !important;
  color: rgb(var(--placeholder-primary));
  font-size: 32px;
  font-style: normal;
  font-weight: 510;
  line-height: 32px; /* 100% */
  letter-spacing: -0.5px;
  padding: 0 !important;
  caret-color: rgb(var(--accent-brand));
  text-indent: 4px;
  width: 100%;
  border: none;
  box-shadow: none;
  outline: none;
}

.en9t9NhwKQnDss6x7Xea::placeholder {
  color: rgb(var(--placeholder-secondary));
}

.b9e9Irf2twDO9FkJjrbB {
  background: rgba(var(--secondary-bg), 0.40);
  padding: 12px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 10px;
}
.b9e9Irf2twDO9FkJjrbB:active {
  outline: 1px solid rgb(var(--placeholder-tertiary));
}
/* .selectBtn:hover {
  outline: 1px solid rgb(var(--placeholder-tertiary));
} */

.UnxsuOgcoALy5sGuAMaG {
  margin-bottom: 16px;
}

.b9e9Irf2twDO9FkJjrbB > svg {
  width: 24px;
  height: 24px;
}

.PwO6rd4AsbmkdhiLUWlw {
  display: flex;
  align-items: center;
  gap: 10px;
}

.PwO6rd4AsbmkdhiLUWlw > img {
  border-radius: 50%;
}

.d5nkxmfaLrhN3K_tf70i {
  font-size: 20px;
  font-style: normal;
  font-weight: 510;
  line-height: 24px;
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-primary));
  text-align: left;
}
._8HpnsqtjOPxj5TGIKHBh {
  font-size: 13px;
  font-weight: 400;
  line-height: 157.143%;
  letter-spacing: 0.43px;
  color: rgb(var(--placeholder-secondary));
  text-align: left;
  text-transform: uppercase;
  margin-bottom: 7px;
}

.fISQDmPHNK4K4ATV56fw {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.07px;
  color: rgb(var(--placeholder-secondary));
  text-align: left;
  padding-left: 3px;
}

.cgC73wJXwfols0IowESS {
  background:transparent;
  width: 292px;
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 auto;
  padding: 0;
}

.cT7kAVhSFECp4JSZi0uc {
  margin: 0 auto;
  font-weight: 760;
  cursor: pointer;
}

.cgC73wJXwfols0IowESS > div > input {
  border: none;
  background: #FFFFFF;
  padding: 5px 0;
  width: 100%;
}

.q3UjgAqIO_j7VZrXoSkJ {
  position: absolute;
  background: #E5F1FF;
  width: 91%;
  top: 87px;
  max-height: 60px;
  border-radius: 0 0 10px 10px;
}

.mLL8sfQEy09kdqRLaNZr {
  max-height: 60px;
  overflow-y: auto;
}

.xe_L0TvfMEhEUhfBn9_x > svg {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

@keyframes R9zuL58nwsdHFFhCHFw8 {
  0% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.xCiEumCHI6iLeIaH8T0g > svg {
  animation: R9zuL58nwsdHFFhCHFw8 0.3s ease;
}

@media (max-width: 370px) {
  .cgC73wJXwfols0IowESS {
    width: 100%;
  }
}

.PpQDBOSETUqkDuemnvTi {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.gFNZ4ITq668nerdd2_oZ {
  display: flex;
  flex-direction: row;
  gap: 5px;
}
.gVR_RWMcqHBPbwjCrSgO {
  color: #34C759 !important;
}
.DsWnQe2UKolc1fin6_3y {
  color: #FF3B30 !important;
}

.mlwBOPDTcPo51TqfSgRo {
  display: flex;
  flex-direction: row;
  width: calc(100% - 32px);
  justify-content: space-between;
}


.Ca44NeHH0XgRDY5oI6uH {
  text-align: right;
}

.WTGg24lvJFOEqQoRtX_p {
  width: 100%;
  height: 36px;
  background: rgba(var(--secondary-bg), 0.40);
  border-radius: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/amount/amount.module.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,mDAAmD;AACrD;AACA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,yCAAwC;AAC1C;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;AAChC;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;AACrB","sourcesContent":[".inner {\n  background: rgba(var(--secondary-bg), 0.60);\n  border: 1px solid rgba(var(--border), 0.20);\n  border-radius: 24px;\n  padding: 16px 16px 24px 16px;\n  position: relative;\n}\n\n.modal {\n  height: 95%;\n  overflow-y: auto;\n}\n\n.amount {\n  background: transparent !important;\n  color: rgb(var(--placeholder-primary));\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 32px; /* 100% */\n  letter-spacing: -0.5px;\n  padding: 0 !important;\n  caret-color: rgb(var(--accent-brand));\n  text-indent: 4px;\n  width: 100%;\n  border: none;\n  box-shadow: none;\n  outline: none;\n}\n\n.amount::placeholder {\n  color: rgb(var(--placeholder-secondary));\n}\n\n.selectBtn {\n  background: rgba(var(--secondary-bg), 0.40);\n  padding: 12px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  gap: 10px;\n}\n.selectBtn:active {\n  outline: 1px solid rgb(var(--placeholder-tertiary));\n}\n/* .selectBtn:hover {\n  outline: 1px solid rgb(var(--placeholder-tertiary));\n} */\n\n.selectBtnMain {\n  margin-bottom: 16px;\n}\n\n.selectBtn > svg {\n  width: 24px;\n  height: 24px;\n}\n\n.selectBtnInner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.selectBtnInner > img {\n  border-radius: 50%;\n}\n\n.selectBtnToken {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 24px;\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-primary));\n  text-align: left;\n}\n.topTitle {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 157.143%;\n  letter-spacing: 0.43px;\n  color: rgb(var(--placeholder-secondary));\n  text-align: left;\n  text-transform: uppercase;\n  margin-bottom: 7px;\n}\n\n.selectBtnAmount {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  letter-spacing: -0.07px;\n  color: rgb(var(--placeholder-secondary));\n  text-align: left;\n  padding-left: 3px;\n}\n\n.amountInner {\n  background:transparent;\n  width: 292px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n  padding: 0;\n}\n\n.amountMax {\n  margin: 0 auto;\n  font-weight: 760;\n  cursor: pointer;\n}\n\n.amountInner > div > input {\n  border: none;\n  background: #FFFFFF;\n  padding: 5px 0;\n  width: 100%;\n}\n\n.tokenList {\n  position: absolute;\n  background: #E5F1FF;\n  width: 91%;\n  top: 87px;\n  max-height: 60px;\n  border-radius: 0 0 10px 10px;\n}\n\n.jettons {\n  max-height: 60px;\n  overflow-y: auto;\n}\n\n.modalOpen > svg {\n  transform: rotate(180deg);\n  transition: transform 0.3s ease;\n}\n\n@keyframes closeModalAnimation {\n  0% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n.modalClose > svg {\n  animation: closeModalAnimation 0.3s ease;\n}\n\n@media (max-width: 370px) {\n  .amountInner {\n    width: 100%;\n  }\n}\n\n.topWrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n\n.usdPriseWrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n}\n.upChange {\n  color: #34C759 !important;\n}\n.downChange {\n  color: #FF3B30 !important;\n}\n\n.rowWrapper {\n  display: flex;\n  flex-direction: row;\n  width: calc(100% - 32px);\n  justify-content: space-between;\n}\n\n\n.rightText {\n  text-align: right;\n}\n\n.skeleton {\n  width: 100%;\n  height: 36px;\n  background: rgba(var(--secondary-bg), 0.40);\n  border-radius: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inner": `lv3TBzI1gVkrBfShzAjb`,
	"modal": `Y7POEWdWqd27HanXSA4G`,
	"amount": `en9t9NhwKQnDss6x7Xea`,
	"selectBtn": `b9e9Irf2twDO9FkJjrbB`,
	"selectBtnMain": `UnxsuOgcoALy5sGuAMaG`,
	"selectBtnInner": `PwO6rd4AsbmkdhiLUWlw`,
	"selectBtnToken": `d5nkxmfaLrhN3K_tf70i`,
	"topTitle": `_8HpnsqtjOPxj5TGIKHBh`,
	"selectBtnAmount": `fISQDmPHNK4K4ATV56fw`,
	"amountInner": `cgC73wJXwfols0IowESS`,
	"amountMax": `cT7kAVhSFECp4JSZi0uc`,
	"tokenList": `q3UjgAqIO_j7VZrXoSkJ`,
	"jettons": `mLL8sfQEy09kdqRLaNZr`,
	"modalOpen": `xe_L0TvfMEhEUhfBn9_x`,
	"modalClose": `xCiEumCHI6iLeIaH8T0g`,
	"closeModalAnimation": `R9zuL58nwsdHFFhCHFw8`,
	"topWrapper": `PpQDBOSETUqkDuemnvTi`,
	"usdPriseWrapper": `gFNZ4ITq668nerdd2_oZ`,
	"upChange": `gVR_RWMcqHBPbwjCrSgO`,
	"downChange": `DsWnQe2UKolc1fin6_3y`,
	"rowWrapper": `mlwBOPDTcPo51TqfSgRo`,
	"rightText": `Ca44NeHH0XgRDY5oI6uH`,
	"skeleton": `WTGg24lvJFOEqQoRtX_p`
};
export default ___CSS_LOADER_EXPORT___;
